import {
  AddCarrierAccountDto,
  AddCarrierBolDto,
  AddCarrierCityDto,
  AddCarrierDispatchDto,
  AddCarrierServiceDto,
  AddEditSetLaneDto,
  AddFuelSurchargeDto,
  AddMarkupDto,
  AddPackageTypesDto,
  AddPermissionDto,
  AddPickupRestrictionDto,
  AddProjectDto,
  AddJobDto,
  AddPromoCodeDto,
  AddSaveAddressDto,
  AddSaveBrokerDto,
  AddSaveContactDto,
  AddSavePackageDto,
  AddTrackingDto,
  AddUserAccountDto,
  AddUserDto,
  AddWebhookDto,
  AddressDto,
  BCFieldsDto,
  BillingAddressDto,
  ContactDto,
  CreateAccountDto,
  ManualLegDto,
  ReferenceRouteFormDto,
  SignUpFormDto,
  UploadRateSheetDto,
  addPackageComodity,
  pickupValidationPayloadDto,
  saveQuotePayloadDto,
} from '../types';
import { AddEditAnnouncementDto } from '../types/announcements';

export const addressInitialValues: AddressDto = {
  address: '',
  city: '',
  country: 'CA',
  province: 'AB',
  postal_code: '',
  has_shipping_bays: null,
};

export const addressInitialVendorValues: AddressDto = {
  address: '',
  city: '',
  country: 'CA',
  province: 'AB',
  postal_code: '',
  has_shipping_bays: null,
};

export const contactInitialValues: ContactDto = {
  company_name: '',
  name: '',
  phone: '',
  email: '',
};
export const contactValidationInitialValues = {
  company_name: false,
  name: false,
  phone: false,
  email: false,
};
export const addressValidationInitialValues = {
  address: false,
  city: false,
  postal_code: false,
  has_shipping_bays: false,
};
export const contactValidationTrueValues = {
  company_name: true,
  name: true,
  phone: true,
  email: true,
};
export const addressValidationTrueValues = {
  address: true,
  city: true,
  postal_code: true,
  has_shipping_bays: true,
};
export const ShipmentPackageValidationValues = {
  packageType: true,
  description: false,
  quantity: true,
  weight: false,
  height: false,
  width: false,
  length: false,
  nog: true,
};
export const packageValidationTrueValues = {
  packageType: true,
  description: true,
  quantity: true,
  weight: true,
  height: true,
  width: true,
  length: true,
  nog: true,
};
export const billingAddressInitialValues: BillingAddressDto = {
  address: '',
  city: '',
  country: 'CA',
  province: 'AB',
  postal_code: '',
  company: '',
  name: '',
  phone: '',
  email: '',
};
export const RefernceRouteInitialValues: ReferenceRouteFormDto = {
  reference_1: '',
  reference_2: '',
  project_name: '',
  booking_date: new Date().toISOString(),
};

export const ShipmentRouteValidationValues = {
  origin_address: false,
  origin_city: false,
  origin_country: true,
  origin_province: true,
  origin_postal_code: false,
  origin_is_residential: false,
  destination_address: false,
  destination_city: false,
  destination_country: true,
  destination_province: true,
  destination_postal_code: false,
  destination_is_residential: false,
  shipper_company: false,
  shipper_name: false,
  shipper_phone: false,
  shipper_email: false,
  consignee_company: false,
  consignee_name: false,
  consignee_phone: false,
  consignee_email: false,
};
export const QuoteRouteValidationValues = {
  origin_address: false,
  origin_city: false,
  origin_country: true,
  origin_province: true,
  origin_postal_code: false,
  origin_is_residential: false,
  destination_address: false,
  destination_city: false,
  destination_country: true,
  destination_province: true,
  destination_postal_code: false,
  destination_is_residential: false,
};
export const billingAddressValidationValues = {
  address: false,
  city: false,
  country: true,
  province: true,
  postal_code: false,
  company: false,
  name: false,
  phone: false,
  email: false,
};
export const signUpDetailFormValidationValues = {
  first_name: false,
  last_name: false,
  email: false,
  phone: false,
};
export const pickupValidationPayloadInitialValues: pickupValidationPayloadDto =
  {
    date: new Date(),
    startTime: '',
    endTime: '',
  };
export const pickupPayloadValidationValues = {
  date: true,
  startTime: true,
  endTime: true,
};
export const priorityOptions = [
  { id: '1', value: 'LO', name: 'Low' },
  { id: '2', value: 'ST', name: 'Standard' },
  { id: '3', value: 'RU', name: 'Rush' },
  { id: '4', value: 'CR', name: 'Critical' },
];
export const travelModeOptions = [
  { id: '1', value: '0', name: 'N/A' },
  { id: '2', value: '1', name: 'Road Only' },
  { id: '3', value: '2', name: 'Flyable(Not Ideal)' },
  { id: '4', value: '3', name: 'Flyable' },
  { id: '5', value: '4', name: 'Sea/Barge' },
];
export const jobHistoryStatusOptions = [
  { id: '1', value: 'CREATED', name: 'Created' },
  { id: '2', value: 'STAGED', name: 'Staged' },
  { id: '3', value: 'READY', name: 'Ready for Pickup' },
  { id: '4', value: 'IN_TRANSIT', name: 'In Transit' },
  { id: '5', value: 'COMPLETED', name: 'Completed' },
];
export const legStatusOptions = [
  { id: '0', value: '0', name: 'All' },
  { id: '1', value: '1', name: 'Created' },
  { id: '2', value: '2', name: 'Pickup' },
  { id: '3', value: '3', name: 'InTransit' },
  { id: '4', value: '4', name: 'OutForDelivery' },
  { id: '5', value: '5', name: 'Undeliverable' },
  { id: '6', value: '6', name: 'Delivered' },
];
export const shipmentStatusOptions = [
  { id: '0', value: '0', name: 'All' },
  { id: '3', value: '3', name: 'Cancelled' },
  { id: '4', value: '4', name: 'Cancelling' },
  { id: '2', value: '2', name: 'Delivered' },
  { id: '1', value: '1', name: 'In Progress' },
];

export const jobStatusOptions = [
  { id: '0', value: 'All', name: 'All' },
  { id: '3', value: 'CANCELLED', name: 'Cancelled' },
  { id: '2', value: 'CREATED', name: 'Created' },
  { id: '1', value: 'IN_PROGRESS', name: 'In Progress' },
];

export const jobFilterStatusOptions = [
  { id: '0', value: 'CREATED', name: 'Created' },
  { id: '1', value: 'IN_PROGRESS', name: 'In Progress' },
  { id: '2', value: 'COMPLETED', name: 'Completed' },
  { id: '3', value: 'CANCELLED', name: 'Cancelled' },
];

export const savedQuotesOptions = [
  { id: '0', value: 'All', name: 'All' },
  { id: '1', value: 'Quoted', name: 'Quoted' },
  { id: '2', value: 'Shipped', name: 'Shipped' },
];
export const overdueOptions = [
  { id: '0', value: '0', name: 'All' },
  { id: '1', value: '1', name: 'Delivery' },
  { id: '2', value: '2', name: 'Pickup' },
];
export const notificationActions = [
  { id: 'NTU', value: 'No Tracking Updates', name: 'No Tracking Updates' },
  { id: 'ATE', value: 'All Tracking Events', name: 'All Tracking Events' },
  { id: 'ODE', value: 'Only Delivered Events', name: 'Only Delivered Events' },
];
export const packagesMetricOptions = [
  { id: '0', value: 'Metric (cm/kg)', name: 'Metric (cm/kg)' },
  { id: '1', value: 'Imperial (in/lbs)', name: 'Imperial (in/lbs)' },
];
export const residentialOption = [
  { id: '0', value: 'Yes', name: 'Yes' },
  { id: '1', value: 'No', name: 'No' },
];
export const docsTypes = [
  { value: '-1', name: 'Select Type' },
  { value: '1', name: 'Insurance Certificate' },
  { value: '2', name: 'Commercial Invoice' },
  { value: '3', name: 'Customs Declaration' },
  { value: '5', name: 'B13A' },
  { value: '7', name: 'DG Dec' },
  { value: '8', name: 'Customer PO' },
  { value: '10', name: 'Packing List' },
  { value: '99', name: 'Other' },
];
export const legDocsTypes = [
  { value: '-1', name: 'Select Type' },
  { value: '0', name: 'Bill of Lading/Airway Bill' },
  { value: '1', name: 'Cargo Label' },
  { value: '2', name: 'Proof of Delivery' },
  { value: '3', name: 'Proof of Pickup' },
  { value: '4', name: 'Weight & Inspection Certificate' },
  { value: '7', name: 'Marine Form' },
  { value: '99', name: 'Other' },
];
export const freightClasses = [
  { value: '-1', name: 'Choose class' },
  { value: '50.00', name: 'class 50' },
  { value: '55.00', name: 'class 55' },
  { value: '60.00', name: 'class 60' },
  { value: '65.00', name: 'class 65' },
  { value: '70.00', name: 'class 70' },
  { value: '77.50', name: 'class 77.5' },
  { value: '85.00', name: 'class 85' },
  { value: '92.50', name: 'class 92.5' },
  { value: '100.00', name: 'class 100' },
  { value: '110.00', name: 'class 110' },
  { value: '125.00', name: 'class 125' },
  { value: '150.00', name: 'class 150' },
  { value: '175.00', name: 'class 175' },
  { value: '200.00', name: 'class 200' },
  { value: '250.00', name: 'class 250' },
  { value: '300.00', name: 'class 300' },
  { value: '400.00', name: 'class 400' },
  { value: '500.00', name: 'class 500' },
];
export const trackingStatusOptions = [
  { value: '-1', label: 'Select Status' },
  { value: 'Created', label: 'Created' },
  { value: 'Pickup', label: 'Picked Up' },
  { value: 'InTransit', label: 'In Transit' },
  { value: 'OutForDelivery', label: 'Out For Delivery' },
  { value: 'Delivered', label: 'Delivered' },
  { value: 'DeliveryException', label: 'Delivery Exception' },
];

export const trackingHourOptions = [
  { value: '-1', label: 'Select Hour' },
  ...Array.from({ length: 24 }, (_, index) => ({
    value: index.toString().padStart(2, '0'),
    label: index.toString().padStart(2, '0'),
  })),
];

export const trackingMinuteOptions = [
  { value: '-1', label: 'Select Minutes' },
  ...Array.from({ length: 60 }, (_, index) => ({
    value: index.toString().padStart(2, '0'),
    label: index.toString().padStart(2, '0'),
  })),
];

export const timesObj = [
  '00:00',
  '00:30',
  '01:00',
  '01:30',
  '02:00',
  '02:30',
  '03:00',
  '03:30',
  '04:00',
  '04:30',
  '05:00',
  '05:30',
  '06:00',
  '06:30',
  '07:00',
  '07:30',
  '08:00',
  '08:30',
  '09:00',
  '09:30',
  '10:00',
  '10:30',
  '11:00',
  '11:30',
  '12:00',
  '12:30',
  '13:00',
  '13:30',
  '14:00',
  '14:30',
  '15:00',
  '15:30',
  '16:00',
  '16:30',
  '17:00',
  '17:30',
  '18:00',
  '18:30',
  '19:00',
  '19:30',
  '20:00',
  '20:30',
  '21:00',
  '21:30',
  '22:00',
  '22:30',
  '23:00',
  '23:30',
  '24:00',
];

export const packagesFormInitialValue: any = {
  id: null,
  package_type: 'BOX',
  package_description: 'Package',
  description: '',
  quantity: '',
  length: '',
  width: '',
  height: '',
  weight: '',
  nog_id: '302',
  units: '0',
  is_metric: true,
  is_dangerous_good: false,
  freight_class: '-1',
  package_id: '1',
  is_cos: false,
  is_pharma: false,
  time_sensitive_hours: undefined,
  is_time_sensitive: false,
  un_number: undefined,
  dg_nos_description: undefined,
  dg_neq_description: undefined,
  dg_quantity: undefined,
  is_nos: undefined,
  is_neq: undefined,
  proper_shipping_name: undefined,
  packing_group: undefined,
  packing_group_name: undefined,
  packing_type: undefined,
  packing_type_name: undefined,
  year: undefined,
  make: undefined,
  model: undefined,
  vin: undefined,
  condition: undefined,
  anti_theft: undefined,
  container_number: undefined,
  status_name: 'EMPT',
};

export const PackageContainerValidations = {
  container_number: false,
};

export const PackageContainerTrueValidations = {
  container_number: true,
};

export const PackageVehicalValidations = {
  year: false,
  make: false,
  model: false,
  vin: false,
};

export const PackageVehicalTrueValidations = {
  year: true,
  make: true,
  model: true,
  vin: true,
};

export const PackageDGValidations = {
  un_number: false,
  dg_quantity: false,
  packing_group_name: false,
  packing_type: false,
};

export const AddSaveAddressInitialValues: AddSaveAddressDto = {
  name: '',
  address: {
    address: '',
    city: '',
    country: 'CA',
    province: 'AB',
    postal_code: '',
    has_shipping_bays: false,
  },
  username: '',
  account_number: '',
  is_origin: true,
  is_destination: true,
};
export const AddSaveAddressValidationValues = {
  name: false,
  address: false,
  city: false,
  postal_code: false,
};
export const editSaveAddressValidationValues = {
  name: true,
  address: true,
  city: true,
  postal_code: true,
};
export const AddContactInitialValues: AddSaveContactDto = {
  contact: {
    company_name: '',
    name: '',
    phone: '',
    email: '',
  },
  username: '',
  account_number: '',
  is_origin: true,
  is_destination: true,
};
export const AddContactValidationValues = {
  name: false,
  company_name: false,
  email: false,
  phone: false,
};
export const editContactValidationValues = {
  company_name: true,
  email: true,
  phone: true,
  name: true,
};
export const AddBrokerInitialValues: AddSaveBrokerDto = {
  contact: {
    company_name: '',
    name: '',
    phone: '',
    email: '',
  },
  address: {
    address: '',
    address_two: '',
    city: '',
    country: 'CA',
    province: 'AB',
    postal_code: '',
    has_shipping_bays: false,
  },
};
export const AddBrokerValidationValues = {
  name: false,
  company_name: false,
  email: false,
  phone: false,
  address: false,
  city: false,
  country: true,
  province: true,
  postal_code: false,
};
export const editBrokerValidationValues = {
  company_name: true,
  email: true,
  phone: true,
  name: true,
  address: true,
  city: true,
  country: true,
  province: true,
  postal_code: true,
};
export const savePackageInitialValue: AddSavePackageDto = {
  package_type: 'BOX',
  description: '',
  length: '',
  width: '',
  height: '',
  weight: '',
  freight_class_id: '-1.00',
  account_number: '',
  box_type: 'NORM_BOX',
  package_id: '1',
  package_description: 'Package',
};

export const freightForArray = [
  'SKID',
  'BUNDLES',
  'CONTAINER',
  'CRATE',
  'DRUM',
  'PAIL',
  'REEL',
  'ROLLS',
  'ROLL',
  'TOTES',
  'TUBE',
  'VEHICLE',
];

export const savePackageValidationValues = {
  description: false,
  length: false,
  width: false,
  height: false,
  weight: false,
};
export const savePackageValidationTrueValues = {
  description: true,
  length: true,
  width: true,
  height: true,
  weight: true,
};
export const saveQuotePayloadForm: saveQuotePayloadDto = {
  all_rates: {},
  company_name: '',
  details: {},
  fees: [],
  name: '',
  phone: '',
  email: '',
  selected_rates: {},
  terms: [],
  account_number: '',
  username: '',
};
export const addUserInitialValues: AddUserDto = {
  role: null,
  first_name: '',
  last_name: '',
  email: '',
  phone: '',
  webhook_tracking_change: 'NTU',
  webhook_tracking_email: '',
};
export const addUserInitialValidations = {
  first_name: false,
  last_name: false,
  email: false,
  phone: false,
};
export const addUserTrueValidations = {
  first_name: true,
  last_name: true,
  email: true,
  phone: true,
};
export const addPermissionInitialValues: AddPermissionDto = {
  name: '',
  permissions: '',
  reason: '',
  category: '',
  is_active: true,
  is_admin: true,
};
export const addPermissionInitialValidations = {
  name: false,
  permissions: false,
  category: false,
};
export const addPermissionTrueValidations = {
  name: true,
  Permissions: true,
  category: true,
};
export const apiCategories = {
  AC: 'Account Apis',
  AA: 'Admin Apis',
  BC: 'Business Central Apis',
  CA: 'Carrier Apis',
  DG: 'Dangerous Goods Apis',
  GA: 'Google Apis',
  ME: 'Metric Apis',
  lA: 'Location Apis',
  MA: 'Main Apis',
  OA: 'Option Apis',
  RA: 'Report Apis',
  SA: 'Shipment Apis',
  SK: 'Skyline Apis',
  NA: 'N/A',
};
export const AddPortInitialValues = {
  address: {
    address: '',
    city: '',
    country: 'CA',
    province: 'AB',
    has_shipping_bays: true,
    postal_code: '',
  },
  code: '',
  name: '',
};
export const AddPortInitialValidations = {
  address: false,
  city: false,
  postal_code: false,
  code: false,
  name: false,
};
export const AddPortTrueValidations = {
  address: true,
  city: true,
  country: true,
  province: true,
  postal_code: true,
  code: true,
  name: true,
};
export const AddPickupRestrictionInitialValue: AddPickupRestrictionDto = {
  carrier_code: null,
  carrier_name: '',
  max_end_time: '',
  max_pickup_days: 0,
  max_start_time: '',
  min_end_time: '',
  min_start_time: '',
  min_time_same_day: '',
  pickup_window: 1,
};
export const AddPickupRestrictionInitialValidation = {
  carrier_code: false,
  max_end_time: false,
  max_start_time: false,
  min_end_time: false,
  min_start_time: false,
  min_time_same_day: false,
  max_pickup_days: true,
  pickup_window: true,
};
export const AddPickupRestrictionTrueValidation = {
  carrier_code: true,
  max_end_time: true,
  max_start_time: true,
  min_end_time: true,
  min_start_time: true,
  min_time_same_day: true,
  max_pickup_days: true,
  pickup_window: true,
};
export const AddFuelInitialValues: AddFuelSurchargeDto = {
  carrier_code: null,
  fifty_five_thou_greater: '',
  ten_thou_to_fifty_five_thou: '',
  ten_thou_under: '',
  updated_date: '',
  fuel_type: 'D',
};
export const AddFuelInitialValidation = {
  carrier_code: false,
  fifty_five_thou_greater: false,
  ten_thou_to_fifty_five_thou: false,
  ten_thou_under: false,
  updated_date: false,
};
export const AddFuelTrueValidation = {
  carrier_code: true,
  fifty_five_thou_greater: true,
  ten_thou_to_fifty_five_thou: true,
  ten_thou_under: true,
  updated_date: true,
};
export const AddProjectInitialValues: AddProjectDto = {
  owner: '',
  code: '',
  name: '',
  description: '',
  start_date: '',
  end_date: '',
};
export const AddProjectInitialValidation = {
  owner: false,
  code: false,
  name: false,
  description: false,
  start_date: false,
  end_date: false,
};
export const AddProjectTrueValidation = {
  owner: true,
  code: true,
  name: true,
  description: true,
  start_date: true,
  end_date: true,
};
export const AddJobSummaryTrueValidation = {
  priority_code: true,
  status_code: true,
  travel_mode_code: true,
  initial_planned_pickup_date: true,
  revised_pickup_date: true,
  actual_pickup_date: true,
  initial_planned_staging_date: true,
  revised_staging_date: true,
};
export const AddJobInitialValues: AddJobDto = {
  project_code: '',
  reference_one: '',
  reference_two: '',
  purchase_order: '',
};
export const AddPromoCodeInitialValue: AddPromoCodeDto = {
  amount: 0,
  code: '',
  end_date: null,
  flat_amount: undefined,
  is_active: false,
  is_bulk: false,
  max_discount: '',
  min_shipment_cost: '',
  percentage: undefined,
  quantity: 0,
  start_date: null,
};
export const AddMarkupInitialValue: AddMarkupDto = {
  default_carrier_percentage: '',
  default_percentage: '',
  description: '',
  is_template: true,
  name: '',
};
export const AddMarkupInitialValidation = {
  default_carrier_percentage: false,
  default_percentage: false,
  description: false,
  name: false,
};
export const AddMarkupTrueValidation = {
  default_carrier_percentage: true,
  default_percentage: true,
  description: true,
  name: true,
};

export const AddCarrierServiceInitialValues: AddCarrierServiceDto = {
  carrier_code: '',
  code: '',
  description: '',
  exceptions: '',
  is_international: false,
  name: '',
  service_days: '',
};

export const AddCarrierServiceInitialValidation = {
  carrier_code: false,
  name: false,
  code: false,
  description: false,
  service_days: false,
};
export const AddCarrierServiceTrueValidation = {
  carrier_code: true,
  name: true,
  code: true,
  description: true,
  service_days: true,
};
export const AddCarrierCityInitialValues: AddCarrierCityDto = {
  carrier_code: '',
  alias: '',
  country: '',
  province: '',
  name: '',
};

export const AddCarrierCityInitialValidation = {
  carrier_code: false,
  alias: false,
  name: false,
  country: false,
  province: false,
};
export const AddCarrierCityTrueValidation = {
  carrier_code: true,
  alias: true,
  name: true,
  country: true,
  province: true,
};

export const AddCarrierDispatchInitialValues: AddCarrierDispatchDto = {
  carrier_code: '',
  contact: {
    company_name: '',
    name: '',
    phone: '',
    email: '',
  },
  location: '',
  is_default: false,
};

export const AddCarrierDispatchInitialValidation = {
  carrier_code: false,
  company_name: false,
  name: false,
  phone: false,
  email: false,
};
export const AddCarrierDispatchTrueValidation = {
  carrier_code: true,
  company_name: true,
  name: true,
  phone: true,
  email: true,
};

export const AddCarrierBolInitialValues: AddCarrierBolDto = {
  carrier_code: '',
  dispatch_id: '',
  bill_of_lading: '',
  is_available: false,
};

export const AddCarrierBolInitialValidation = {
  carrier_code: false,
  dispatch_id: false,
  bill_of_lading: false,
};
export const AddCarrierBolTrueValidation = {
  carrier_code: true,
  dispatch_id: true,
  bill_of_lading: true,
};
export const AddAccountInitialValues: CreateAccountDto = {
  client_account: 1,
  address: {
    address: '',
    city: '',
    province: 'AB',
    country: 'CA',
    postal_code: '',
    has_shipping_bays: true,
  },
  contact: {
    company_name: '',
    name: '',
    phone: '',
    email: '',
    first_name: '',
    last_name: '',
  },
  markup: '-1',
  markup_percentage: '',
  bc_type: 'NF',
  bc_customer_code: '',
  bc_job_number: '',
  bc_location_code: 'YEGFFAPP',
  bc_line_type: '3',
  bc_item: 'TRANSPORTATION',
  bc_file_owner: `BBEX\LHARDER`,
  is_bc_push: false,
  is_account_id: false,
  id_prefix: '',
  is_dangerous_good: false,
  is_pharma: false,
  is_metric_included: true,
  carriers: [],
  is_payment: false,
  is_terms_agreed: false,
  has_seen_terms: false,
};
export const AddAccountValidationValues = {
  company_name: false,
  phone: false,
  email: false,
  first_name: false,
  last_name: false,
  markup: false,
};
export const AddAccountAddressValidationValues = {
  address: false,
  city: false,
  postal_code: false,
};
export const AddAccountBCValidationValues = {
  bc_customer_code: false,
  bc_location_code: true,
  bc_item: true,
  bc_file_owner: true,
};

export const BCShippingFields: BCFieldsDto = {
  bc_type: 'NF',
  bc_customer: '',
  bc_location: 'YEGFF',
  bc_job_number: '-1',
  bc_customer_reference_one: '',
  bc_customer_reference_two: '',
  bc_customer_reference_three: 'Regular',
  bc_planning_lines: [],
  bc_username: '',
};
export const BCPlanningLinesInitialValue = [
  {
    leg: 'Allin',
    line_type: '2',
    item: 'TRANSPORTATION',
    markup: '',
    branch_code: '130',
    cost_centre: '210',
    location_code: 'YEGFF',
  },
  {
    leg: 'Handling',
    line_type: '2',
    item: 'FF_SHIP_HANDLING',
    markup: '',
    branch_code: '130',
    cost_centre: '210',
    location_code: 'YEGFF',
  },
];

export const AddCarrierAccountInitialValues: AddCarrierAccountDto = {
  account: '',
  account_number: '',
  api_key: '',
  carrier_code: '',
  contract_number: '',
  password: '',
  username: '',
};

export const AddCarrierAccountInitialValidation = {
  account: false,
  account_number: false,
  api_key: false,
  carrier_code: false,
  contract_number: false,
  password: false,
  username: false,
};
export const AddCarrierAccountTrueValidation = {
  account: true,
  account_number: true,
  api_key: true,
  carrier_code: true,
  contract_number: true,
  password: true,
  username: true,
};

export const AddUserAccountInitialValues: AddUserAccountDto = {
  account: '',
  role: '7',
  username: '',
  email: '',
  first_name: '',
  last_name: '',
  phone: '',
  is_price_hide: false,
  is_vendor: false,
  is_business_central: false,
  carriers: [],
  bc_username: '',
  bc_location_code: 'YEGFF',
  bc_cost_center: '210',
  bc_branch_code: '130',
};

export const AddUserDetailsInitialValidations = {
  first_name: false,
  last_name: false,
  email: false,
  phone: false,
};

export const AddPackageTypesInitialValues: AddPackageTypesDto = {
  account_name: 'gobox@bbex.com',
  name: '',
  code: '',
  max_overall_dims: '',
  max_weight: '',
  is_dangerous_good: false,
  is_pharma: false,
  is_common: false,
  is_active: false,
  carrier: [],
  carriers: [],
};

export const AddWebhookInitialValues: AddWebhookDto = {
  account_number: '',
  event: 'TSC',
  data_format: 'JSO',
  url: '',
};

export const AddWebhookInitialValidations = {
  account_number: false,
  url: false,
};
export const AddWebhookTruValidations = {
  account_number: true,
  url: true,
};

export const AddTrackingInitialValues: AddTrackingDto = {
  estimated_delivery_datetime: '',
  delivered_datetime: '',
  status: '',
  leg_id: '',
  details: '',
};

export const AddTrackingInitialValidations = {
  estimated_delivery_datetime: false,
  status: false,
  leg_id: false,
  details: false,
};

export const AddTrackingTrueValidations = {
  estimated_delivery_datetime: true,
  status: true,
  leg_id: true,
  details: true,
};

export const BCSettingsTrueValidationValues = {
  bc_username: true,
  bc_location_code: true,
  bc_branch_code: true,
  bc_cost_centre: true,
};

export const AddManualLegInitialValidations = {
  type: false,
  carrier_code: false,
  service_code: false,
  tracking_identifier: false,
  carrier_pickup_identifier: false,
  freight: false,
  surcharge: false,
  tax: false,
  cost: false,
  transit_days: false,
};

export const AddManualLegInitialValue: ManualLegDto = {
  shipment_id: '',
  postfix: '',
  type: '',
  origin: addressInitialValues,
  destination: addressInitialValues,
  carrier_id: null,
  carrier_code: '',
  carrier_name: '',
  service_code: '',
  service_name: '',
  tracking_identifier: '',
  carrier_pickup_identifier: '',
  freight: '',
  surcharge: '',
  tax: '',
  cost: '',
  is_dangerous_good: false,
  transit_days: '',
  estimated_delivery_date: new Date().toISOString(),
  legValidations: AddManualLegInitialValidations,
  leg_added: '',
};

export const UploadRateSheetInitialValues: UploadRateSheetDto = {
  file: '',
  account_number: '',
  carrier_code: null,
  service_name: '',
  service_code: '',
  rs_type: 'PHP',
};

export const UploadRateSheetInitialValidations = {
  file: false,
  account_number: false,
  carrier_code: false,
  service_name: false,
  service_code: false,
};

export const UploadRateSheetTrueValidations = {
  file: false,
  account_number: false,
  carrier_code: false,
  service_name: false,
  service_code: false,
};

export const addPackageComodityInitialValidations = {
  quantity: false,
  description: false,
  made_in_country_code: false,
  unit_value: false,
  total_weight: false,
};

export const addPackageComodityInitialValue: addPackageComodity = {
  item_id: null,
  package_id: null,
  quantity: null,
  description: '',
  made_in_country_code: '',
  unit_value: '',
  total_weight: '',
  quantity_unit_of_measure: 'Each',
  validations: addPackageComodityInitialValidations,
};

export const addSetLaneInitialValues: AddEditSetLaneDto = {
  origin_airport: '',
  destination_airport: '',
  middle_airport: '',
  airline_one: '',
  airline_two: '',
  is_transfer_required: false,
  transfer_carriers: [],
  carriers: [],
};

export const addAnnouncementInitialValues: AddEditAnnouncementDto = {
  publish_date: '',
  end_date: '',
  type: '',
  title: '',
  snippet: '',
  content: '',
  is_email: false,
  is_sent: false,
};

export const addSetLaneInitialValidationValues: any = {
  origin_airport: false,
  destination_airport: false,
  middle_airport: false,
  airline_one: false,
  airline_two: false,
};

export const addSetLaneTrueValidationValues: any = {
  origin_airport: true,
  destination_airport: true,
  middle_airport: true,
  airline_one: true,
  airline_two: true,
};
export const addAnnouncementInitialValidationValues: any = {
  publish_date: false,
  end_date: false,
  type: false,
  title: false,
  snippet: false,
  content: true,
};

export const addAnnouncementTrueValidationValues: any = {
  publish_date: true,
  end_date: true,
  type: true,
  title: true,
  snippet: true,
  content: true,
};

export const signUpInitialValues: SignUpFormDto = {
  company_name: '',
  phone: '',
  email: '',
  first_name: '',
  last_name: '',
  password_one: '',
  password_two: '',
  recaptcha_response: '',
};

export const signUpValidationValues: any = {
  company_name: false,
  phone: false,
  email: false,
  first_name: false,
  last_name: false,
  password_one: false,
  password_two: false,
  recaptcha_response: false,
};
